import React from "react";

import { useTheme } from "../../hooks/useTheme";

/**
 * LoadingFallback component
 *
 * Provides a minimal loading indicator for use with React.Suspense
 * Shows a centered loading state with subtle animation
 */
const LoadingFallback: React.FC = () => {
  const { themeClasses } = useTheme();

  return (
    <div className="flex items-center justify-center w-full py-20">
      <div className="flex flex-col items-center space-y-4">
        <div className="w-12 h-12 border-4 border-t-primary-600 border-r-primary-300 border-b-primary-100 border-l-primary-300 rounded-full animate-spin"></div>
        <p className={`font-medium ${themeClasses.text}`}>Loading...</p>
      </div>
    </div>
  );
};

export default LoadingFallback; 
